import { getPassScope, isCategoryIncludesExpert } from "@/components/Package/getPassScope";
import { numberFormatter } from "@/lib/utils";
import dayjs from "dayjs";
import { PassCategory, TicketDeductionMethod } from "src/api/membership";
// 엑스퍼트 detailProducts 표기 순서 (레거시 PassInfoModal 차용)
const DETAIL_PRODUCT_ORDER = [
    "본문분석",
    "워크북",
    "변형문제",
    "기출문제",
    "외부지문"
];
const formatTitle = (title)=>title === "기출문제" ? "기출적중 모의고사" : title;
function sortByProductOrder(items) {
    return items.slice().sort((a, b)=>{
        const aIndex = DETAIL_PRODUCT_ORDER.findIndex((keyword)=>a.title.includes(keyword));
        const bIndex = DETAIL_PRODUCT_ORDER.findIndex((keyword)=>b.title.includes(keyword));
        return (aIndex === -1 ? DETAIL_PRODUCT_ORDER.length : aIndex) - (bIndex === -1 ? DETAIL_PRODUCT_ORDER.length : bIndex);
    });
}
const getUnit = (title)=>title.includes("변형문제") ? "문제" : "개";
/**
 * amount(금액 차감) 이용권 여부.
 * owned 는 ticket.deductionMethod (Ticket 타입상 required) 우선 — productInfo.deductionMethod 가
 * 누락된 응답에서 amount 이용권을 회 단위로 잘못 표시하는 것을 방어.
 */ const isAmountPass = (input)=>{
    var _input_ticket_deductionMethod;
    const method = input.mode === "owned" ? (_input_ticket_deductionMethod = input.ticket.deductionMethod) !== null && _input_ticket_deductionMethod !== void 0 ? _input_ticket_deductionMethod : input.pass.deductionMethod : input.pass.deductionMethod;
    return method === TicketDeductionMethod.AMOUNT;
};
/** FreePass + count 외 deduction → 횟수 표기 대신 '사용범위 내 무제한' */ const isNoCountLimitPass = (pass)=>pass.category === PassCategory.FreePass && pass.deductionMethod !== TicketDeductionMethod.COUNT;
/** 월 만료 이용권은 남은 기간·만료일을 서버값이 아닌 '이번 달 말' 기준으로 파생한다 */ const buildOwnedPeriodRow = (pass, ticket)=>{
    var _pass_isExpireMonthly;
    const isExpireMonthly = (_pass_isExpireMonthly = pass.isExpireMonthly) !== null && _pass_isExpireMonthly !== void 0 ? _pass_isExpireMonthly : false;
    const remainDay = isExpireMonthly ? dayjs().endOf("month").diff(dayjs().startOf("day"), "day") : ticket.remainDay;
    const startedAt = dayjs(ticket.startedAt).format("YYYY.MM.DD");
    // 만료일은 시간 단위까지 표기 (레거시 parity)
    const expiredAt = isExpireMonthly ? dayjs().endOf("month").format("YYYY.MM.DD HH:mm:ss") : dayjs(ticket.expiredAt).format("YYYY.MM.DD HH:mm:ss");
    return {
        label: "남은 기간",
        value: "".concat(remainDay, "일 (").concat(startedAt, " ~ ").concat(expiredAt, ")")
    };
};
/**
 * 요약 영역. mode 별 분기가 모이는 유일한 지점이며, 표기할 내용이 없으면 null 을 반환해
 * 섹션 자체가 사라진다 (만료된 보유 이용권).
 */ const buildSummarySection = (input)=>{
    const { pass , mode  } = input;
    const isAmount = isAmountPass(input);
    const isNoCountLimit = isNoCountLimitPass(pass);
    // 엑스퍼트는 상품 단위 횟수 대신 '엑스퍼트 사용범위' 표로 표기 → 횟수 행 숨김
    const isExpert = isCategoryIncludesExpert(pass.category);
    const rows = [];
    if (mode === "purchase") {
        if (!isExpert) {
            var _pass_availableAmount, _pass_availableCount;
            rows.push(isNoCountLimit ? {
                value: "사용범위 내 무제한",
                tone: "highlight"
            } : {
                label: isAmount ? "총 사용 가능 금액" : "총 사용 가능 횟수",
                value: isAmount ? "".concat(numberFormatter((_pass_availableAmount = pass.availableAmount) !== null && _pass_availableAmount !== void 0 ? _pass_availableAmount : 0), "원") : "".concat(numberFormatter((_pass_availableCount = pass.availableCount) !== null && _pass_availableCount !== void 0 ? _pass_availableCount : 0), "회")
            });
        }
        rows.push({
            label: "사용 기간",
            value: "결제일로부터 ".concat(pass.period, "일간")
        });
        return {
            id: "summary",
            layout: "inline",
            rows
        };
    }
    const { ticket  } = input;
    // 만료 이용권은 남은 횟수·기간 표기가 의미 없어 요약을 통째로 생략한다
    if (ticket.isExpired) return null;
    if (!isExpert) {
        var _ticket_remainAmount;
        var _ticket_remainCount;
        rows.push(isNoCountLimit ? {
            value: "사용범위 내 무제한",
            tone: "strong"
        } : {
            label: isAmount ? "남은 금액" : "남은 횟수",
            value: isAmount ? "".concat(((_ticket_remainAmount = ticket.remainAmount) === null || _ticket_remainAmount === void 0 ? void 0 : _ticket_remainAmount.toLocaleString()) || 0, "원") : "".concat(numberFormatter((_ticket_remainCount = ticket.remainCount) !== null && _ticket_remainCount !== void 0 ? _ticket_remainCount : 0) || 0, "회"),
            tone: "strong"
        });
        if (!isNoCountLimit) {
            var _pass_availableAmount1;
            var _pass_availableCount1;
            rows.push({
                label: isAmount ? "총 사용 가능 금액" : "총 사용 가능 횟수",
                value: isAmount ? "".concat(((_pass_availableAmount1 = pass.availableAmount) === null || _pass_availableAmount1 === void 0 ? void 0 : _pass_availableAmount1.toLocaleString()) || 0, "원") : "".concat(((_pass_availableCount1 = pass.availableCount) !== null && _pass_availableCount1 !== void 0 ? _pass_availableCount1 : 0).toLocaleString(), "회")
            });
        }
    }
    rows.push(buildOwnedPeriodRow(pass, ticket));
    return {
        id: "summary",
        layout: "inline",
        rows
    };
};
/** 이용권 사용범위 — 값이 빈 행은 제거 */ const buildScopeSection = (pass)=>({
        id: "scope",
        layout: "table",
        title: "이용권 사용범위",
        labelWidth: "sm",
        rows: getPassScope(pass).filter((scope)=>scope.value !== "").map((scope)=>({
                label: scope.type,
                value: scope.value
            }))
    });
/**
 * 엑스퍼트 사용범위. 보유(detailProductStatus)는 잔여 수량을 강조하고,
 * 미보유(detailProducts)는 제공 수량만 표기한다.
 */ const buildExpertScopeSection = (input)=>{
    var _input_ticket_detailProductStatus, _pass_detailProducts;
    const { pass , mode  } = input;
    if (!isCategoryIncludesExpert(pass.category)) return null;
    // 만료 이용권은 잔여 수량 표기가 의미 없어 숨김
    if (mode === "owned" && input.ticket.isExpired) return null;
    let rows = [];
    if (mode === "owned" && ((_input_ticket_detailProductStatus = input.ticket.detailProductStatus) === null || _input_ticket_detailProductStatus === void 0 ? void 0 : _input_ticket_detailProductStatus.length)) {
        rows = sortByProductOrder(input.ticket.detailProductStatus).map((product)=>{
            const isUnlimited = !product.isLimited && product.total === null;
            const isRemaining = isUnlimited || product.remain !== null && product.remain > 0;
            const unit = getUnit(product.title);
            var _product_remain, _product_total;
            return {
                label: formatTitle(product.title),
                value: isUnlimited ? "무제한" : "".concat(((_product_remain = product.remain) !== null && _product_remain !== void 0 ? _product_remain : 0).toLocaleString()).concat(unit, " 남음"),
                suffix: isUnlimited ? undefined : " / 총 ".concat(((_product_total = product.total) !== null && _product_total !== void 0 ? _product_total : 0).toLocaleString()).concat(unit),
                tone: isRemaining ? "success" : "error"
            };
        });
    } else if ((_pass_detailProducts = pass.detailProducts) === null || _pass_detailProducts === void 0 ? void 0 : _pass_detailProducts.length) {
        rows = sortByProductOrder(pass.detailProducts).map((product)=>{
            const unit = getUnit(product.title);
            var _product_count;
            return {
                label: formatTitle(product.title),
                value: product.isLimited ? "".concat(((_product_count = product.count) !== null && _product_count !== void 0 ? _product_count : 0).toLocaleString()).concat(unit) : "무제한"
            };
        });
    }
    if (!rows.length) return null;
    return {
        id: "expertScope",
        layout: "table",
        title: "엑스퍼트 사용범위",
        labelWidth: "md",
        rows
    };
};
/**
 * 이용권 상세정보 — 개행 단위 불릿.
 * description 이 비어도 섹션 자체는 유지한다 (기존 렌더 parity).
 */ const buildDescriptionSection = (pass)=>({
        id: "description",
        layout: "bullets",
        title: "이용권 상세정보",
        items: pass.description ? pass.description.split("\n") : []
    });
/**
 * 다이얼로그 본문 섹션 파생. 렌더 트리와 무관한 순수 함수라 단위 테스트가 가능하다.
 * null 을 반환한 빌더는 제거돼 '섹션의 유무' 자체가 결과 배열에 표현된다.
 */ export const getPassInfoSections = (input)=>[
        buildSummarySection(input),
        buildScopeSection(input.pass),
        buildExpertScopeSection(input),
        buildDescriptionSection(input.pass)
    ].filter((section)=>section !== null);
